import { SetData as UseCaseReduxSetData } from '~/domain/usecases/message/redux';

import { ReduxSetData } from '~/data/store/reducer/message/usecases/ReduxSetData';

/**
 * send request via REDUX.
 */
export const makeReduxSetData = (): UseCaseReduxSetData => new ReduxSetData();
